import { TriangleAlert } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'

type PackagingSupplierNameCellProps = {
  supplierId: string
  name: string
  notInSourceList: boolean
}

export function PackagingSupplierNameCell({
  supplierId,
  name,
  notInSourceList,
}: PackagingSupplierNameCellProps) {
  const { t } = useTranslation('packagingSuppliers')

  return (
    <span className='flex min-w-0 items-center gap-1.5'>
      <Link
        to={`/packaging/suppliers/${supplierId}`}
        className='truncate text-foreground underline decoration-dotted underline-offset-2'
      >
        {name}
      </Link>
      {notInSourceList && (
        <Tooltip>
          <TooltipTrigger asChild>
            <span
              className='inline-flex shrink-0 text-amber-600 dark:text-amber-500'
              aria-label={t('list.notInSourceListTooltip')}
            >
              <TriangleAlert className='size-3.5' aria-hidden />
            </span>
          </TooltipTrigger>
          <TooltipContent side='top' className='max-w-xs'>
            {t('list.notInSourceListTooltip')}
          </TooltipContent>
        </Tooltip>
      )}
    </span>
  )
}
